import React from 'react'

import Download from '../../components/blog/download'
import Testimonial from '../../components/blog/Testimonial'
import Collection_category from '../../components/collectrions/collection_category'
import { Auctions_categories, Bids, Browse_category, Partners } from '../../components/component'
import Hero_6 from '../../components/hero/hero_6'
import Meta from '../../components/Meta'

const Home_6 = () => {
  return (
    <>
      <Meta title="Home 6 || Xhibiter | NFT Marketplace Next.js Template" />
      <Hero_6 />
      <Bids />
      <Collection_category bgWhite={true} />
      <Auctions_categories />
      <Browse_category bgWhite={true} />
      <Testimonial bgWhite={true} />
      <Partners />
      <Download />
    </>
  )
}

export default Home_6
